import React from "react";

// Minimalist line-art candlestick chart icon (Neo-Brutalist).
// Pure black strokes, no fill gradients. Strokes are thick for high contrast.
const CandlestickIcon = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 240 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Candlestick chart illustration"
    >
      {/* Axis */}
      <line x1="20" y1="10" x2="20" y2="180" stroke="#000" strokeWidth="4" />
      <line x1="20" y1="180" x2="230" y2="180" stroke="#000" strokeWidth="4" />

      {/* Dashed grid baseline */}
      <line x1="20" y1="100" x2="230" y2="100" stroke="#000" strokeWidth="2" strokeDasharray="4 6" />

      {/* Candle 1 - bullish (filled green) */}
      <line x1="50" y1="40" x2="50" y2="150" stroke="#000" strokeWidth="3" />
      <rect x="40" y="70" width="20" height="55" fill="#00FF41" stroke="#000" strokeWidth="3" />

      {/* Candle 2 - bearish (white/hollow) */}
      <line x1="90" y1="30" x2="90" y2="160" stroke="#000" strokeWidth="3" />
      <rect x="80" y="55" width="20" height="80" fill="#FFFFFF" stroke="#000" strokeWidth="3" />

      {/* Candle 3 - bullish */}
      <line x1="130" y1="50" x2="130" y2="140" stroke="#000" strokeWidth="3" />
      <rect x="120" y="75" width="20" height="45" fill="#00FF41" stroke="#000" strokeWidth="3" />

      {/* Candle 4 - bearish */}
      <line x1="170" y1="20" x2="170" y2="135" stroke="#000" strokeWidth="3" />
      <rect x="160" y="40" width="20" height="75" fill="#FFFFFF" stroke="#000" strokeWidth="3" />

      {/* Candle 5 - bullish small */}
      <line x1="210" y1="60" x2="210" y2="150" stroke="#000" strokeWidth="3" />
      <rect x="200" y="90" width="20" height="40" fill="#00FF41" stroke="#000" strokeWidth="3" />

      {/* Trend arrow */}
      <path d="M40 160 L100 120 L140 135 L210 70" fill="none" stroke="#000" strokeWidth="3" strokeDasharray="6 4" />
      <polygon points="205,66 222,62 214,80" fill="#000" />
    </svg>
  );
};

export default CandlestickIcon;
